"use client";

import React from "react";
import RelatedTopics from "@/components/tools/RelatedTopics";
import Hero from "@/components/tools/Hero";
import AllOn6Intro from "@/components/services/all-on-6/AllOn6Intro";
import AstoriaTrustedDentist from "@/components/services/all-on-6/AstoriaTrustedDentist";
import WhatAreAllOn6Implants from "@/components/services/all-on-6/WhatAreAllOn6Implants";
import BenefitsOfAllOn6 from "@/components/services/all-on-6/BenefitsOfAllOn6";
import { AreAllOn6RightForYou } from "@/components/services/all-on-6/AreAllOn6RightForYou";
import AllOn4VsAllOn6 from "@/components/services/all-on-6/AllOn4VsAllOn6";
import TreatmentProcess from "@/components/services/all-on-6/TreatmentProcess";
import AllOn6Cost from "@/components/services/all-on-6/AllOn6Cost";
import WhyChooseSmile4Me from "@/components/services/all-on-6/WhyChooseSmile4Me";
import FinalCta from "@/components/services/all-on-6/FinalCta";
import FAQ from "@/components/tools/FAQ";

const allOn6FAQs = [
  {
    question: "Are All-on-6 dental implants painful?",
    answer:
      "The procedure is performed under local anesthesia, with sedation options available. Most patients find that post-surgery discomfort fades within a few days and is manageable with prescribed medication.",
  },
  {
    question: "How long do All-on-6 dental implants last?",
    answer:
      "With proper care and regular check-ups, the implant posts can last a lifetime. The prosthetic arch may need adjustment or replacement after a decade or more, depending on wear.",
  },
  {
    question: "Can I get implants if I have bone loss?",
    answer:
      "Bone loss does not automatically disqualify you. A 3D scan during your consultation will show exactly what's needed, including whether bone grafting is an option.",
  },
  {
    question: "How do I get started?",
    answer:
      "Call our office at (718) 400-4400 or book online to schedule your free consultation. There's no pressure and no obligation.",
  },
];

const AllOn6: React.FC = () => {
  return (
    <>
      <Hero
        imageSrc="/images/photo-smiling-couple-with-dog-outdoors-discussing-full-mouth-dental-implants-astoria-in-sunny-park-setting.jpg"
        imageAlt="photo-smiling-couple-with-dog-outdoors-discussing-full-mouth-dental-implants-astoria-in-sunny-park-setting"
        imagePosition="center 10%"
        title="All-on-6 Full Mouth Dental Implants Astoria, Queens, NY"
        ctaText="Schedule a Free Consultation"
        ctaLink="/contact"
      />
      <main className="flex-1 py-8">
        <div className="flex flex-col lg:flex-row mx-auto px-4 sm:px-8 md:px-12">
          <article className="flex-1 space-y-8 pr-0 lg:pr-8">
            <AllOn6Intro />
            <AstoriaTrustedDentist />
            <WhatAreAllOn6Implants />
            <BenefitsOfAllOn6 />
            <AreAllOn6RightForYou />
            <AllOn4VsAllOn6 />
            <TreatmentProcess />
            <AllOn6Cost />
            <WhyChooseSmile4Me />
            <FAQ title="Frequently Asked Questions" faqs={allOn6FAQs} />
            <FinalCta />
          </article>
          <RelatedTopics
            topics={[
              { label: "All-on-4®", url: "/services/all-on-4/" },
              { label: "Implant Dentistry", url: "/services/implant-dentistry/" },
              { label: "Implant Restorations", url: "/services/implant-restorations/" },
              { label: "Dental Bridges", url: "/services/dental-bridges/" },
              { label: "Dentures", url: "/services/dentures/" },
              {
                label: "Full Mouth Reconstruction",
                url: "/services/full-mouth-reconstruction/",
              },
            ]}
          />
        </div>
      </main>
    </>
  );
};

export default AllOn6;
